export default "__VITE_ASSET__BJzsXMNe__"